<template>
<div class="image-view">
<div class="image-view__inner">
<img src="../assets/img/img-nenkin-teikibin-35-45.png" alt="" v-if="value1 === 35 || value1 === 45">
<img src="../assets/img/img-nenkin-teikibin-59.png" alt="" v-else-if="value1 === 59">
<img src="../assets/img/img-nenkin-teikibin-under-50.png" alt="" v-else-if="value1 < 50">
<img src="../assets/img/img-nenkin-teikibin-over-50.png" alt="" v-else>
</div>
<p class="button-close"><button type="button" @click="closeByEvent"><span class="button-close__inner">閉じる</span></button></p>
</div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'value1'
            ])
        },
        beforeRouteEnter(to, from, next) {
            document.body.style.overflow = 'hidden';
            next();
        },
        methods: {
            closeByEvent(event) {
                event.preventDefault();

                window.close();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/ImageViewNenkinTeikibin.vue